import { render, staticRenderFns } from "./AccountOrderDetailsBackorderedGrid.vue?vue&type=template&id=b1adbc4c&"
import script from "./AccountOrderDetailsBackorderedGrid.vue?vue&type=script&lang=js&"
export * from "./AccountOrderDetailsBackorderedGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports